import { SxProp, View } from 'dripsy';
import React from 'react';
import { H4 } from '@/design-system/components/typography/UniTypography';
import { PageNavigation } from './PageNavigation';
import { SegmentSelectItem } from '@/design-system/components/buttons/segmentSelect/SegmentSelect';

interface PageHeaderProps<T> {
  title: string;
  data?: Array<SegmentSelectItem<T>>;
  currentPage?: T;
  sx?: SxProp;
  titleSx?: SxProp;
}

export const PageHeader = <T extends unknown>({ title, currentPage, data, sx, titleSx }: PageHeaderProps<T>) => {
  return (
    <View sx={{ ...styles.container, ...sx }}>
      <H4 bold sx={{ flex: 1, color: '$textPrimary', ...titleSx }}>
        {title}
      </H4>
      {data && <PageNavigation data={data} currentPage={currentPage} />}
    </View>
  );
};

enum StyleName {
  container = 'container'
}

const styles: Record<StyleName, SxProp> = {
  container: {
    mb: '$10',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'flex-start',
    position: 'relative'
  }
};
